module.exports = __webpack_public_path__ + "img/yuangong.5e09c0e2.png";